import type { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar,
  IconButton,
  MenuIcon,
  Toolbar,
  Typography,
  useTheme,
} from '@/shared/ui/mui';
import { ShopSwitcher } from '@/features/multi-tenancy/ShopSwitcher';
import type { BootstrapShop } from '@/shared/api/bootstrap';
import { dashTokens } from '@/shared/styles/dashboard.tokens';
import type { User } from '@/shared/types';

interface DashboardAppBarProps {
  onMenuToggle: () => void;
  user: User | null;
  showMenuButton: boolean;
  shops?: BootstrapShop[];
  currentShopSlug?: string;
}

export const DashboardAppBar: FC<DashboardAppBarProps> = ({
  onMenuToggle,
  user: _user,
  showMenuButton,
  shops = [],
  currentShopSlug,
}) => {
  const theme = useTheme();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: 'var(--promo-offset, 0px)',
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: theme.palette.common.white,
        boxShadow: 'none',
        borderBottom: `1px solid ${dashTokens.borderSubtle}`,
      }}
    >
      <Toolbar sx={{ minHeight: 64 }}>
        {showMenuButton && (
          <IconButton
            edge="start"
            onClick={onMenuToggle}
            sx={{ mr: 1, color: theme.palette.grey[700] }}
            aria-label="Open navigation menu"
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography
          variant="h6"
          component={RouterLink}
          to="/"
          sx={{
            flexGrow: 1,
            color: theme.palette.primary.main,
            fontWeight: 700,
            letterSpacing: '-0.5px',
            textDecoration: 'none',
            fontSize: { xs: '1.1rem', sm: '1.3rem' },
          }}
        >
          Donvio
        </Typography>

        {shops.length > 0 && (
          <ShopSwitcher
            shops={shops}
            currentShopSlug={currentShopSlug}
          />
        )}
      </Toolbar>
    </AppBar>
  );
};
